import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const CATEGORY_ID_RULE_EDITOR_CLASS_NAME = 'CategoryIdRuleEditor';
export const CATEGORY_ID_RULE_EDITOR_CLASS_SLOTS = ['root'] as const;

export type CategoryIdRuleEditorClassSlot =
	(typeof CATEGORY_ID_RULE_EDITOR_CLASS_SLOTS)[number];

export interface CategoryIdRuleEditorClasses {
	root: string;
}

export type CategoryIdRuleClassKey = keyof CategoryIdRuleEditorClasses;

export const getCategoryIdRuleEditorUtilityClass = (slot: string) =>
	generateUtilityClass(CATEGORY_ID_RULE_EDITOR_CLASS_NAME, slot);

export const categoryIdRuleEditorClasses: CategoryIdRuleEditorClasses =
	generateUtilityClasses(CATEGORY_ID_RULE_EDITOR_CLASS_NAME, ['root']);

export default categoryIdRuleEditorClasses;
